<div class="help-option-selector">
    <div class="help-option-selector__header">
        <eb-h2>{{ 'help.modal.title' | transloco }}</eb-h2>
    </div>

    <eb-choice-buttons
        class="help-option-selector__options"
        [isToggleBehavior]="false"
        [ngModel]="null"
        (ngModelChange)="onOptionSelect($event)"
    >
        @if (hasCalendly()) {
            <eb-choice-button
                [id]="'appointment'"
                [title]="'help.modal.option_appointment' | transloco"
                [subtitle]="'help.modal.option_appointment_description' | transloco"
                [isAltDesign]="true"
                icon="ui/common/calendar"
            />
        }
        @if (hasFormContacts()) {
            <eb-choice-button
                [id]="'forms'"
                [title]="'help.modal.option_forms' | transloco"
                [subtitle]="'help.modal.option_forms_description' | transloco"
                [isAltDesign]="true"
                icon="ui/nav/contact"
            />
        }
    </eb-choice-buttons>
</div>
